import Box from "@mui/material/Box";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";

import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";

import {
  actionMapMapviewChangeRequested,
  selectorMapZoom,
} from "../Map/MapRedux";
import Tooltip from "@mui/material/Tooltip";
import ZoomSlider from "./ZoomSlider";

const root_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "4px",
});

const widget_ = (theme) => ({
  // 44x44 min size is needed to meet this accessibility requirement:
  // https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html
  width: 44,
  height: 44,
  minWidth: "unset",
  backgroundColor: "#ffffff",
  border: "1px solid #f0f0f0",
  [theme.breakpoints.down("sm")]: {
    width: 34,
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
  },
});

const zoomBtns_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "transparent",
  boxShadow: "none",
  "&:hover": {
    "& button": {
      borderRadius: "0px",
    },
  },
});

const zoomIn_ = (theme) => ({
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  borderBottom: "none",
});

const zoomOut_ = (theme) => ({
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderTop: "none",
});

const expand_ = (theme) => ({
  paddingTop: "0px",
  paddingBottom: "0px",
  backgroundColor: "rgba(213, 213, 213, 0.5)",
  borderRadius: "0px",
  border: "none",
  "&:hover": {
    backgroundColor: "rgba(213, 213, 213, 0.95)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem",
  },
  [theme.breakpoints.down("sm")]: {
    display: "none !important",
  },
});

export default function ZoomButton({ factor }) {
  const dispatch = useDispatch();
  const zoom = useSelector(selectorMapZoom);

  const [expandVisible, setExpandVisible] = useState(false);
  const [expand, setExpand] = useState(false);

  const expandClick = () => {
    setExpand(!expand);
  };
  const handlePopoverOpen = () => {
    setExpandVisible(true);
  };
  const handlePopoverClose = () => {
    setExpandVisible(false);
  };

  const zoomHandler = (value) => () => {
    dispatch(
      actionMapMapviewChangeRequested({
        zoom: zoom + value,
      }),
    );
  };

  const handleChange = (_, newValue) => {
    dispatch(
      actionMapMapviewChangeRequested({
        zoom: newValue,
        fromSlider: true,
      }),
    );
  };

  return (
    <Box sx={root_}>
      <Paper
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={zoomBtns_}
        data-testid="zoom-button"
        title={zoom}
      >
        <Tooltip title="Zoom In">
          <Button
            onClick={zoomHandler(factor)}
            variant="contained"
            sx={[widget_, zoomIn_]}
            data-testid="zoom-in"
          >
            <AddIcon />
          </Button>
        </Tooltip>
        <Collapse in={expand}>
          <ZoomSlider zoom={zoom} handleChange={handleChange} />
        </Collapse>
        <Tooltip title="Zoom Out">
          <Button
            onClick={zoomHandler(-1 * factor)}
            variant="contained"
            sx={[widget_, zoomOut_]}
            data-testid="zoom-out"
          >
            <RemoveIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Toggle Zoom Slider">
          <Button
            style={{ visibility: expandVisible ? "visible" : "hidden" }}
            variant="contained"
            sx={[widget_, expand_]}
            onClick={expandClick}
          >
            {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Button>
        </Tooltip>
      </Paper>
    </Box>
  );
}
